module.exports = __webpack_public_path__ + "media/images/welcome-questionnaires-169b7bfe943d3ff1a715a45614737b2c.jpg";